<template>
  <div>
    <DataTable
      :value="accounts"
      :filters="filters"
      :selection.sync="selectedRows"
      paginatorPosition="top"
      dataKey="branchCode"
      :rowHover="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers p-my-4"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      currentPageReportTemplate="{first} to {last} of {totalRecords} Accounts"
      :scrollable="true"
      frozenWidth="50px"
      scrollHeight="400px"
      :resizableColumns="true" 
      columnResizeMode="expand"
      @row-click="$emit('accountClicked', $event)"
    >
      <!-- <template #header>
        Linked Accoutns
      </template> -->

      <Column
        field="branchCode"
        header="Branch Code"
        :sortable="true"
        headerStyle="width: 5em; text-align: left;"
      >
      </Column>
      <Column
        field="branchName"
        header="Branch Name"
        :sortable="true"
        headerStyle="width: 10em; text-align: left;"
      >
      </Column>
      <Column
        field="tasCode"
        header="TAS Code"
        :sortable="true"
        headerStyle="width: 5em; text-align: left;"
      >
      </Column>
      <Column
        field="active"
        header="Active?"
        :sortable="true"
        headerStyle="width: 5em; text-align: left;"
      >
        <template #body="slotProps">
          <Button v-if="slotProps.data.active"
            @click="activeClicked(slotProps.data)"
            label="Yes"
            icon="pi pi-check"
            style="width: 100%"
            class="p-button-primay p-button-raised"
          />
          <Button v-else
            @click="activeClicked(slotProps.data)"
            label="No"
            icon="pi pi-times" 
            style="width: 100%"
            class="p-button-text p-button-raised"
          />
        </template>
      </Column>
      <Column
        field="salesExecName"
        header="Sales Exec Name"
        :sortable="true"
        headerStyle="width: 5em; text-align: left;"
      >
      </Column>
      <Column 
        field="mainBranch"
        header="Main Branch?"
        :sortable="true"
        headerStyle="width: 5em; text-align: left;"
      >
        <template #body="slotProps">
          <i @click="branchClicked(slotProps.data)" v-if="slotProps.data.mainBranch" class="pi pi-check" style="fontSize: 2rem"></i>
        </template>
      </Column>
      <Column 
        field="removeLink"
        header="Remove Link"
        :sortable="true"
        headerStyle="width: 5em; text-align: left;"
      >
        <template #body="slotProps">
          <ProgressSpinner 
            v-if="removingLink && removingLink.custBranchId === slotProps.data.custBranchId && removingLink.branchId === slotProps.data.branchId"
            style="width:25px; height:25px; width: 100px; float:right;" 
            strokeWidth="5" 
            fill="#EEEEEE" 
            animationDuration=".5s"
          />
          <Button 
            v-else
            label="Remove"  
            @click="$emit('removeLink', slotProps.data)" 
            class="p-button-danger" 
            autofocus 
            :disabled="!slotProps.data.customerId"
          />
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
export default {
  props: {
    removingLink: {
      type: Object,
      required: false
    },
    accounts: {
      type: Array,
      required: true
    },
    filters: {
      type: Object,
      required: false
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    selectedRows: []
  }),
  methods: {
    branchClicked(account) {
      this.$toast.add({
        severity: "warn",
        summary: "Warning",
        detail: "To change the Main Branch, select the Branch which will become the new Main Branch and set it as the new Main Branch",
        life: 5000,
      })
    },
    activeClicked(account) {
      setTimeout(() => {
        // 
        this.$emit('accountClicked', account)
      }, 1)
    }
  }
}
</script>

<style>

</style>